import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';
import { ELEVATED } from 'shared/styles/shadows';

export default makeStyles({
  root: {
    position: 'absolute',
    width: '28.75rem',
    transform: 'translate(calc(50vw - 14rem),calc(50vh - 8rem))',
    color: neutral[100],
    borderRadius: '0.75rem',
    boxShadow: ELEVATED.regular,
    backgroundColor: neutral.white,
  },
  header: {
    padding: '1.5rem 1rem 0.5rem 1rem',
  },
  title: {
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2rem',
  },

  main: {
    padding: '1rem 1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    fontWeight: 400,
  },

  footer: {
    padding: '0.75rem 1.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '0.75rem',
  },
  btnClose: {
    padding: '0.75rem 1rem',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[80],
    borderRadius: '0.5rem',
    backgroundColor: neutral.white,
    border: `1px solid ${neutral[20]}`,
    '&:hover': {
      color: neutral[100],
      borderColor: neutral[30],
      backgroundColor: neutral[10],
    },
  },
  btnCTA: {
    padding: '0.75rem 1rem',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    borderRadius: '0.5rem',
    color: neutral.white,
    backgroundColor: neutral[90],
    border: `1px solid ${neutral[90]}`,
    '&:hover': {
      color: neutral['20'],
      backgroundColor: neutral[100],
      border: `1px solid ${neutral[100]}`,
    },
  },
});
